import { Request } from '../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../httpClient/serverApi/types/IGetItemsResult';
import { IBackgroundJob } from './IBackgroundJob';

// Raw shape returned by the backend — content fields use the server names before the
// frontend mapper renames them to associatedContent*.
export type IBackgroundJobRaw = Omit<IBackgroundJob, 'associatedContentName' | 'associatedContentId' | 'associatedContentType'> & {
  contentName: string | null;
  contentId: string | null;
  contentType: string | null;
};

export interface IGetBackgroundJobsResult extends IGetItemsResult {
  backgroundJobs: IBackgroundJobRaw[];
}

export class GetBackgroundJobsRequest extends Request<IGetItemsParams, IGetBackgroundJobsResult> {
  constructor(params: IGetItemsParams) {
    super('getBackgroundJobs', params);
  }
}
